var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 298,
    viewBox: "0 0 228 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_833)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 227,
    height: 298,
    rx: 8,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8C0.5 3.58173 4.08172 0 8.5 0H219.5C223.918 0 227.5 3.58172 227.5 8V163.788H0.5V8Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_109_833)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5347,
    y: 195,
    width: 204.597,
    height: 14.7236,
    rx: 7.36182,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5347,
    y: 225.724,
    width: 204.597,
    height: 14.7236,
    rx: 7.36182,
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5347,
    y: 256.447,
    width: 204.597,
    height: 14.7236,
    rx: 7.36182,
    fill: "#E3E3E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_833"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 227,
    height: 298,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_109_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(177.5 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.019e13c3d14ccb4067c7f0bde6333e9e.svg";
export { ForwardRef as ReactComponent };